import ContainerDialog, {
  containerDialogClasses
} from "@bmi-digital/components/container-dialog";
import { iconButtonClasses } from "@bmi-digital/components/icon-button";
import { styled } from "@mui/material/styles";
import Typography from "@bmi-digital/components/typography";

const PREFIX = "VisualiserV2";

export const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  secondary: `${PREFIX}-secondary`,
  groupTitle: `${PREFIX}-groupTitle`,
  content: `${PREFIX}-content`,
  contentTitle: `${PREFIX}-contentTitle`,
  progressContainer: `${PREFIX}-progressContainer`,
  actions: `${PREFIX}-actions`,
  icon: `${PREFIX}-icon`,
  container: `${PREFIX}-container`,
  viewer: `${PREFIX}-viewer`,
  activeSelectionOption: `${PREFIX}-activeSelectionOption`
};

export const StyledChildDialog = styled(ContainerDialog)({
  height: "100%",
  width: "100%",
  [`&.${classes.secondary}`]: {
    boxShadow: "none"
  },
  [`&.${containerDialogClasses.allowOverflow} .${containerDialogClasses.content}`]:
    {
      overflow: "hidden auto"
    }
});

export const StyledParentDialog = styled(ContainerDialog)(({ theme }) => ({
  height: "100vh",
  width: "100vw",
  [`& .${classes.header}`]: {
    flexWrap: "wrap-reverse",
    justifyContent: "space-between",
    alignItems: "center",

    [`& .${iconButtonClasses.root}`]: {
      margin: "10px 10px 12px 24px",

      [theme.breakpoints.down("md")]: {
        margin: "6px 6px 12px 24px"
      }
    }
  },
  [`&.${classes.groupTitle}`]: {
    marginTop: "24px",
    marginBottom: "24px"
  },

  [`& .${classes.content}`]: {
    overflowY: "auto",
    height: "100%",
    backgroundColor: theme.colours.pearl,
    padding: 0
  },
  [`& .${classes.progressContainer}`]: {
    position: "absolute",
    top: "70px",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    backgroundColor: "rgba(255, 255, 255, 0.65)",
    borderRadius: "3px"
  },
  [`& .${classes.container}`]: {
    [theme.breakpoints!.up!("sm")]: {
      padding: "0px 20px"
    }
  },
  [`& .${classes.viewer}`]: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%"
  },
  [`& .${classes.activeSelectionOption}`]: {
    padding: "0px",
    border: `2px solid ${theme.colours.accent}`
  }
}));

export const StyledActions = styled("nav")(({ theme }) => ({
  border: 0,
  left: 0,
  bottom: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.colours.blue800,
  minHeight: "5rem",
  padding: "0.875rem"
}));

export const Title = styled(Typography)(({ theme }) => ({
  margin: "12px 0 12px 30px",
  wordBreak: "break-word",
  width: "calc(100% - 112px)",

  [theme.breakpoints.down("md")]: {
    marginLeft: "18px",
    width: "calc(100% - 96px)"
  }
}));
